var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoorahVids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29365 3.56537C2.77893 3.0373 3.41387 2.70416 4.09496 2.62028C6.21652 2.37205 8.30141 2.37182 10.423 2.62028C11.1041 2.70416 11.739 3.0373 12.2243 3.56537C12.7095 4.09345 13.0165 4.78531 13.0951 5.52814C13.1314 5.88121 13.1622 6.2323 13.1875 6.58201C13.7778 6.23935 14.4199 5.92692 15.0885 5.68737C15.5831 5.51021 16.1188 5.74025 16.2942 6.23545C16.5299 6.90133 16.7581 7.86695 16.7581 8.99995C16.7581 10.1329 16.5299 11.0986 16.2942 11.7645C16.1188 12.2597 15.5831 12.4897 15.0885 12.3125C14.4198 12.0729 13.7776 11.7605 13.1873 11.4177C13.1622 11.7676 13.1318 12.1188 13.0961 12.472C13.0174 13.2148 12.7106 13.9066 12.2252 14.4347C11.74 14.9628 11.105 15.2959 10.4239 15.3799C8.30198 15.6279 6.21692 15.6281 4.09496 15.3799C3.41387 15.2959 2.77892 14.9628 2.29365 14.4347C1.80837 13.9066 1.5014 13.2148 1.42278 12.472C1.18173 10.1292 1.18196 7.87087 1.42278 5.52814C1.5014 4.78531 1.80838 4.09345 2.29365 3.56537Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoorahVids);
export default __webpack_public_path__ + "static/media/shoorahVids.12d4c3fff1cc0d467c29bfdbd2f1ab8e.svg";
export { ForwardRef as ReactComponent };